/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Alerts from './Alerts/index'
import React from 'react'
import TimegridArea from './TimegridArea/index'
import Topbar from './Topbar/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content",
  innerRef
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--blc-1-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<Topbar
  viewPath={`${viewPath}/Topbar`}
 innerRef={innerRef}
/>
<TimegridArea
  viewPath={`${viewPath}/TimegridArea`}
/>
<Alerts
  viewPath={`${viewPath}/Alerts`}
/>
</div>
{children}
</React.Fragment>)
}